export default __webpack_public_path__ + "static/niras-d237035622a83d27cfe80e6bf1776b7d.png";